import SubmenuBlock from './SubmenuBlock';

export default SubmenuBlock;
